export const BANCO_FIHOGAR = 'bancofiogar';
export const IBAN = 'iban';
export const KREDISI = 'kredisi';



// WEBPACK FOOTER //
// ./src/utils/constants/Partners.js